import * as consts from '../constants';

import commonFunctions from '../commonFunctions';

class reportingApi {
    static loadDashboard(token) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/dashboard', 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static loadRendicontazione(token, filers) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/rendicontazione', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static exportRendicontazione(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/exportRendicontazione';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static loadEstrattoConto(token, filters, pagingModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadEstrattoConto', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        ret.sortName = pagingModel.sortName;
                        ret.sortOrder = pagingModel.sortOrder;
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters, pagingModel)));
        });
    }

    static estrattoContoExport(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/exportEstrattoConto';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static marcaPagatoAllaCompagnia(token, ids, targetDate, amount, note) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/marcaPagatoAllaCompagnia', 'PUT');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ ids, targetDate, amount, note }));
        });
    }

    static loadEstrattoContoSociSostenitori(token, filters, pagingModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadEstrattoContoSocioSostenitore', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        ret.sortName = pagingModel.sortName;
                        ret.sortOrder = pagingModel.sortOrder;
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters, pagingModel)));
        });
    }

    
    static estrattoContoSociSostenitoriExport(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/estrattoContosociSostenitoriExport';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static loadEstrattoContoReferenti(token, filters, pagingModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadEstrattoContoReferenti', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        ret.sortName = pagingModel.sortName;
                        ret.sortOrder = pagingModel.sortOrder;
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters, pagingModel)));
        });
    }

    static estrattoContosociReferentiExport(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/estrattoContosociReferentiExport';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static loadEstrattoContoQuoteSociSostenitori(token, filters, pagingModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadEstrattoContoQuoteSociSostenitori', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        ret.sortName = pagingModel.sortName;
                        ret.sortOrder = pagingModel.sortOrder;
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters, pagingModel)));
        });
    }

    static estrattoContoQuoteSociSostenitoriExport(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/estrattoContoQuoteSociSostenitoriExport';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static marcaPagatoAlSocioSostenitore(token, ids, targetDate, networkRights, note) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/marcaPagatoAlSocioSostenitore', 'PUT');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject(JSON.parse(req.response).message);
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ ids, targetDate, amount: networkRights, note }));
        });
    }

    static marcaPagatoAlReferente(token, ids, targetDate, referenteRights) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/marcaPagatoAlReferente', 'PUT');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ ids, targetDate, amount: parseFloat(referenteRights.replace(',', '.')) }));
        });
    }

    static loadEstrattoContoXSocioSostenitore(token, filters, pagingModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadEstrattoContoXSocioSostenitore', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        ret.sortName = pagingModel.sortName;
                        ret.sortOrder = pagingModel.sortOrder;
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters, pagingModel)));
        });
    }

    static estrattoContoXSocioSostenitoreExport(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/estrattoContoXSocioSostenitoreExport';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static loadEstrattoContoIncassi(token, filters, pagingModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadEstrattoContoIncassi', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        ret.sortName = pagingModel.sortName;
                        ret.sortOrder = pagingModel.sortOrder;
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters, pagingModel)));
        });
    }

    static estrattoContoIncassiExport(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/estrattoContoIncassiExport';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static notificaScadenzaPagamentoQuietanza(token, accountPeriodId) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/notificaScadenzaPagamentoQuietanza/' + accountPeriodId;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify());
        });
    }

    static loadCertificazioneIncassi(token, filters, pagingModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadCertificazioneIncassi', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        ret.sortName = pagingModel.sortName;
                        ret.sortOrder = pagingModel.sortOrder;
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters, pagingModel)));
        });
    }

    static printCertificazioneIncassi(token, contractId, year) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/printCertificazioneIncassi?contractId=' + contractId + '&year=' + year;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        if (req.status === 204) {
                            reject('Attenzione l\'ammontare è pari a € 0,00 e quindi il certificato non viene generato.');
                        } else {
                            var ret = JSON.parse(req.response);
                            commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                            resolve();
                        }
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static confirmAndSaveCertificazioneIncassi(token, contractId, year) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/confirmAndSaveCertificazioneIncassi?contractId=' + contractId + '&year=' + year;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        if (req.status === 204) {
                            reject('Attenzione l\'ammontare è pari a € 0,00 e quindi il certificato non viene generato.');
                        } else {
                            var ret = JSON.parse(req.response);
                            commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                            resolve();
                        }
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static confirmAndSaveAllCertificazioneIncassi(token, filters) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/confirmAndSaveAllCertificazioneIncassi?year=' + filters.year
                + '&aderente=' + encodeURI(filters.aderente)
                + '&network=' + encodeURI(filters.network)
                + '&tariffGroupId=' + encodeURI(filters.tariffGroupId);
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve('Certificazioni Generate, si ricorda che non vengono generate certificazioni con € 0,00 di importo.');
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static confirmAndSendCertificazioneIncassi(token, contractId, year) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/confirmAndSendCertificazioneIncassi?contractId=' + contractId + '&year=' + year;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        if (req.status === 204)
                            reject('Attenzione l\'ammontare è pari a € 0,00 e quindi il certificato non viene inviato.');
                        else
                            resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static downloadCertificazioneIncassi(token, contractId, year) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/downloadCertificazioneIncassi?contractId=' + contractId + '&year=' + year;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        if (req.status === 204) {
                            reject('Attenzione l\'ammontare è pari a € 0,00 e quindi il certificato non viene generato.');
                        } else {
                            var ret = JSON.parse(req.response);
                            commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                            resolve();
                        }
                    } else {
                        reject('Problemi durante il tentativo di download!');
                    }
                }
            };
            req.send();
        });
    }

    static certificazioneIncassiExport(token, filters) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/certificazioneIncassiExport?year=' + filters.year
                + '&aderente=' + filters.aderente + '&network=' + filters.network + '&tariffGroupId=' + filters.tariffGroupId;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filters));
        });
    }

    static loadEstrazioneAnagrafiche(token, filters) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/reporting/loadEstrazioneAnagrafiche', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        resolve(ret);
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(Object.assign(filters)));
        });
    }

    static estrazioneAnagraficheExport(token, filters) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/reporting/estrazioneAnagraficheExport';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filters));
        });
    }
}

export default reportingApi;
